var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.newImg),expression:"newImg"}],class:_vm.classText,style:(_vm.styleText)})
}
var staticRenderFns = []

export { render, staticRenderFns }